module.exports = __webpack_public_path__ + "static/img/SmileAnimation_cranberry.9c15f80.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_cranberry.gif
// module id = 8lOn
// module chunks = 0